const colors = [
    '#327acb',
    '#3e577d',
    '#f64937',
    '#eccf5a',
    '#85cfb2',
    '#dfb750',
    '#d1d9e6',
    '#c39a60',
    '#3b9cff',
    '#6ac8ff',
    '#88e7ff',
    '#ff715e',
    '#ff8f7c',
    '#ffbaa5',
    '#ce210f',
    '#b00300',
    '#004899',
] as const;

export const getChartColorByIndex = (index: number): string =>
    colors[index % colors.length];
